import { render, staticRenderFns } from "./PuntosPeligro.vue?vue&type=template&id=cd0af2e2&scoped=true"
import script from "./PuntosPeligro.vue?vue&type=script&lang=ts"
export * from "./PuntosPeligro.vue?vue&type=script&lang=ts"
import style0 from "./PuntosPeligro.vue?vue&type=style&index=0&id=cd0af2e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0af2e2",
  null
  
)

export default component.exports